var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 22.5 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.25 0C8.26752 0.00395631 5.40834 1.19049 3.29942 3.29941C1.19049 5.40834 0.00395631 8.26752 0 11.25C0 19.3265 10.4812 29.4422 10.9266 29.8687C11.0132 29.9529 11.1292 30 11.25 30C11.3708 30 11.4868 29.9529 11.5734 29.8687C12.0187 29.4422 22.5 19.3265 22.5 11.25C22.496 8.26752 21.3095 5.40834 19.2006 3.29941C17.0916 1.19049 14.2325 0.00395631 11.25 0ZM11.25 16.4062C10.2302 16.4062 9.23327 16.1038 8.38533 15.5372C7.53739 14.9707 6.8765 14.1654 6.48624 13.2232C6.09598 12.281 5.99387 11.2443 6.19282 10.2441C6.39177 9.24384 6.88286 8.32509 7.60397 7.60397C8.32509 6.88286 9.24384 6.39177 10.2441 6.19282C11.2443 5.99386 12.281 6.09598 13.2232 6.48624C14.1654 6.8765 14.9707 7.53739 15.5372 8.38533C16.1038 9.23327 16.4062 10.2302 16.4062 11.25C16.4054 12.6173 15.8619 13.9283 14.8951 14.8951C13.9283 15.8619 12.6173 16.4054 11.25 16.4062Z",
    fill: "var(--fill-0, #EE5414)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIconPin);
export default __webpack_public_path__ + "static/media/trusted-icon-pin.c8f52e44d57afe3354280f91db4fcf73.svg";
export { ForwardRef as ReactComponent };